import { useSelector } from "react-redux";

export default function useDateRange() {
    const dateRange = useSelector(state => state.GlobalData.dateRange);
    return dateRange;
}
